import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { EditQuestionAnswersManageAppointment } from '../../common';
import { bookingsApi } from '~/api';

export class EditBookingQuestionAnswers extends PureComponent {
  onSaveDataHandler = (answers) => {
    const { bookingId } = this.props;

    return bookingsApi.updateBooking(bookingId, { answers });
  };

  preloadData = () => Promise.resolve();

  render() {
    return (
      <EditQuestionAnswersManageAppointment
        onSaveDataHandler={this.onSaveDataHandler}
        preloadData={this.preloadData}
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = ({
  appointment: {
    draft: { id: bookingId },
  },
}) => ({
  bookingId,
});

export const ConnectedEditBookingQuestionAnswers = connect(mapStateToProps)(
  EditBookingQuestionAnswers,
);

EditBookingQuestionAnswers.propTypes = {
  bookingId: PropTypes.string.isRequired,
};
